import { connect } from 'react-redux';
import { IRootState } from 'redux/reducer';
import { selectRouteResource } from 'redux/routing/selectors';
import { rrc } from 'utils/strings/resourceClasses';

import { OrganizationProjectsList as Component } from './OrganizationProjectsList.component';

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = typeof mapDispatchToProps;
type IInjectedProps = IStateProps & IDispatchProps;
export type IProps = IInjectedProps;

const mapStateToProps = (rootState: IRootState) => ({
  routeOrganization: selectRouteResource(rrc.organization)(rootState),
});

const mapDispatchToProps = {
  //
};

export const OrganizationProjectsList = connect(mapStateToProps, mapDispatchToProps)(Component);
